jQuery( document ).ready(function($) {
	//homepage slider
	$('.flexslider').flexslider({
		animation: "slide",
		controlNav: true,
		animation: "fade"
  	});
  	//characters carousel
  	$("#characters-carousel").not('.slick-initialized').slick({
  	  infinite: true,
  	  slidesToShow: 3,
  	  slidesToScroll: 3,
  	  autoplay: true,
  	  responsive: [
	      {
	        breakpoint: 1024,
	        settings: {
	          slidesToShow: 2,
	          slidesToScroll: 2,
	          infinite: true
	        }
	      },
	      {
	        breakpoint: 600,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          infinite: true
	        }
	      }
  	    ]
  	});

	//play character audio on click
	$(".portrait .rollover").click(function() {
		$(this).find('#nav_audio')[0].play();
	});
});